import * as SignalR from '@microsoft/signalr';
import chromeExAPI from '@/chromeExAPI';
import { getActiveWorks } from '@/utils/workIdManager';

let ws = null;
let wsStock = null;
let url = null;
let urlStock = null;
let heartbeatInterval = null;

let imageLoadCallback = function imageLoadCallback(base64Wemp, x, y, type) {
  return new Promise((resolve, reject) => {
    let img = new Image();
    img.onload = function () {
      let canvas = document.createElement('canvas');
      canvas.width = x == -1 ? img.width : x;
      canvas.height = y == -1 ? img.height : y;
      let context = canvas.getContext('2d');
      let mimeType = 'image/' + (type == 'jpg' ? 'jpeg' : type);

      context.drawImage(img, 0, 0, x == -1 ? img.width : x, y == -1 ? img.height : y);
      let dataurl = canvas.toDataURL(mimeType);
      resolve(dataurl);
    };
    img.onerror = function () {
      reject(base64Wemp);
    };
    img.src = base64Wemp;
  });
};

// Heartbeat 시작 함수
function startHeartbeat(connection, vueInstance) {
  // 기존 interval 정리
  stopHeartbeat();
  
  // 60초마다 Heartbeat 전송
  heartbeatInterval = setInterval(() => {
    if (connection && connection.connection?._connectionState === 'Connected') {
      connection.invoke('UpdateHeartbeat')
        .then((response) => {
          // 서버 응답 형식: [타임스탬프, IP주소, socketIdx]
          // 예: ["2026-01-21T04:47:22.8581251Z", "192.168.0.2", 0]
          if (Array.isArray(response) && response.length >= 3) {
            const socketIdx = response[2]; // 배열의 세 번째 요소가 socketIdx
            if (vueInstance && vueInstance.socketStore && socketIdx !== undefined && socketIdx !== null) {
              vueInstance.socketStore.setSocketIdx(socketIdx);
              // title 업데이트
              updateTitleWithSocketIdx(vueInstance);
            }
          } else if (response && response.socketIdx !== undefined) {
            // 객체 형태로 오는 경우 (하위 호환)
            if (vueInstance && vueInstance.socketStore) {
              vueInstance.socketStore.setSocketIdx(response.socketIdx);
              updateTitleWithSocketIdx(vueInstance);
            }
          } else if (typeof response === 'string' || typeof response === 'number') {
            // socketIdx가 직접 반환되는 경우 (하위 호환)
            if (vueInstance && vueInstance.socketStore) {
              vueInstance.socketStore.setSocketIdx(response);
              updateTitleWithSocketIdx(vueInstance);
            }
          }
        })
        .catch(err => {
          console.error('Heartbeat 전송 실패:', err);
          // Heartbeat 실패 시 연결 상태 확인 및 재연결 시도
          if (vueInstance && vueInstance.ws_connect) {
            console.log('연결 끊김 감지, 재연결 시도...');
            stopHeartbeat();
            // 재연결 시도
            setTimeout(() => {
              if (vueInstance.$ws?.connection?._connectionState !== 'Connected') {
                vueInstance.ws_connect();
              }
            }, 1000);
          }
        });
    } else {
      // 연결이 끊어진 경우 interval 정리
      stopHeartbeat();
    }
  }, 30000); // 60초마다
}

// Title에 socketIdx 추가하는 함수
function updateTitleWithSocketIdx(vueInstance) {
  if (!vueInstance || !vueInstance.socketStore) return;
  
  const socketIdx = vueInstance.socketStore.getSocketIdx();
  if (socketIdx === null || socketIdx === undefined) return;
  
  // 현재 title 가져오기
  const currentTitle = document.title;
  
  // 기존 socketIdx 패턴 제거 (맨 앞의 숫자- 패턴 또는 끝의 [SocketIdx: ...] 패턴)
  const existingPrefixPattern = /^\d+\s*-\s*/; // 맨 앞의 "숫자-" 패턴
  const existingSuffixPattern = /\s*\[SocketIdx:\s*\d+\]\s*$/; // 끝의 "[SocketIdx: ...]" 패턴
  let baseTitle = currentTitle.replace(existingSuffixPattern, '').replace(existingPrefixPattern, '');
  
  // socketIdx가 이미 포함되어 있는지 확인 (맨 앞에 같은 socketIdx가 있는지)
  const socketIdxPrefixPattern = new RegExp(`^${socketIdx}\\s*-\\s*`);
  if (socketIdxPrefixPattern.test(currentTitle)) {
    return; // 이미 포함되어 있으면 업데이트하지 않음
  }
  
  // 새로운 title 설정: socketIdx를 맨 앞에 붙임
  document.title = `${socketIdx}-${baseTitle}`;
}

// Heartbeat 중지 함수
function stopHeartbeat() {
  if (heartbeatInterval) {
    clearInterval(heartbeatInterval);
    heartbeatInterval = null;
  }
}

// 재접속 처리 함수
async function handleReconnection(connection) {
  try {
    // localStorage에서 활성 작업 ID 목록 가져오기
    const activeWorks = getActiveWorks();
    
    if (activeWorks.length > 0 && connection) {
      // 백엔드에 재접속 알림 및 작업 ID 목록 전송
      await connection.invoke('NotifyReconnection', activeWorks).catch(err => {
        console.error('재접속 알림 전송 실패:', err);
      });
      console.log(`재접속 알림 전송: ${activeWorks.length}개 작업`);
    }
  } catch (error) {
    console.error('재접속 처리 오류:', error);
  }
}

export default {

  install(Vue) {
    url = process.env.VUE_APP_TEST_SOCKET_URL;
    urlStock = process.env.VUE_APP_STOCK_OVERWAY_SOCKET_URL;

    if (window.location.hostname === 'stock.overlink.kr') {
      url = 'https://apistock.omarket.kr/chathub';
      urlStock = 'https://apistock.omarket.kr/chathub';
    }
    else if (['https://omarket.kr','https://api.omarket.kr'].includes(window.location.origin)) {
      url = process.env.VUE_APP_PRODUCT_SOCKET_URL;
      urlStock = process.env.VUE_APP_STOCK_OVERWAY_SOCKET_URL;
    }
    else if (['https://shcolab.co.kr','https://api.shcolab.co.kr'].includes(window.location.origin)) {
      url = process.env.VUE_APP_PRODUCT_SHCOLAB_SOCKET_URL;
      urlStock = process.env.VUE_APP_STOCK_OVERWAY_SOCKET_URL;
    }
    else if (['https://kimmanager.co.kr','https://api.kimmanager.co.kr'].includes(window.location.origin)) {
      url = process.env.VUE_APP_PRODUCT_KIMMANAGER_SOCKET_URL;
      urlStock = process.env.VUE_APP_STOCK_OVERWAY_SOCKET_URL;
    }
    else if (['https://kcode.store','https://api.kcode.store'].includes(window.location.origin)) {
      url = process.env.VUE_APP_PRODUCT_KCODE_SOCKET_URL;
      urlStock = process.env.VUE_APP_STOCK_OVERWAY_SOCKET_URL;
    }
    else if (['https://withjikkoo.kr','https://api.withjikkoo.kr'].includes(window.location.origin)) {
      url = process.env.VUE_APP_PRODUCT_WITHJIKKOO_SOCKET_URL;
      urlStock = process.env.VUE_APP_STOCK_OVERWAY_SOCKET_URL;
    }
    else if (['https://crosssell.co.kr','https://apiv2.omarket.kr'].includes(window.location.origin)) {
      url = process.env.VUE_APP_PRODUCT_CROSSSELL_SOCKET_URL;
      urlStock = process.env.VUE_APP_STOCK_OVERWAY_SOCKET_URL;
    }
    else if (['https://overlink.kr','https://api.overlink.kr'].includes(window.location.origin)) {
      url = process.env.VUE_APP_PRODUCT_OVERWAY_SOCKET_URL;
      urlStock = process.env.VUE_APP_STOCK_OVERWAY_SOCKET_URL;
    }
    else if (['https://zijyasssssell.com','https://api.zijyasssssell.com'].includes(window.location.origin)) {
      url = process.env.VUE_APP_PRODUCT_ZIJYASSSSSELL_SOCKET_URL;
      urlStock = process.env.VUE_APP_STOCK_OVERWAY_SOCKET_URL;
    }
    else if (['https://osonupload.com','https://apiv2.omarket.kr'].includes(window.location.origin)) {
      url = process.env.VUE_APP_PRODUCT_OSONUPLOAD_SOCKET_URL;
      urlStock = process.env.VUE_APP_STOCK_OVERWAY_SOCKET_URL;
    }
    else if (['https://smartcross.kr','https://api.osonupload.com'].includes(window.location.origin)) {
      url = process.env.VUE_APP_PRODUCT_SMARTCROSS_SOCKET_URL;
      urlStock = process.env.VUE_APP_STOCK_OVERWAY_SOCKET_URL;
    }
    else if (['https://localhost:8080'].includes(window.location.origin)) {

      url = process.env.VUE_APP_TEST_SOCKET_URL;
      urlStock = process.env.VUE_APP_STOCK_OVERWAY_SOCKET_URL;
    }
    else {
      url = process.env.VUE_APP_TEST_SOCKET_URL;
      urlStock = process.env.VUE_APP_STOCK_OVERWAY_SOCKET_URL;
    }



    Vue.prototype.ws_connect = function () {
      if (this.$ws?.connection?._connectionState == 'Connected') {
        console.log('연결 되어있음');
        return;
      }
      
      // 도메인이 osonupload.com이면 VUE_APP_PRODUCT_OSONUPLOAD_SOCKET_URL 사용
      let socketUrlToUse = url;
      if (window.location.hostname === 'osonupload.com' || window.location.hostname.includes('osonupload.com') || window.location.hostname === 'smartcross.kr' ) {
        socketUrlToUse = process.env.VUE_APP_PRODUCT_OSONUPLOAD_SOCKET_URL;
        console.log('[WebSocket] 테스트서버 osonupload.com 도메인 감지, OSONUPLOAD Socket URL 사용:', socketUrlToUse);
      }
      // 로그인한 서버의 socketUrl이 있으면 우선 사용 (로드밸런싱 대응)
      else if (this.authStore.socketUrl) {
        socketUrlToUse = this.authStore.socketUrl;
        console.log('[WebSocket] 로그인한 서버의 Socket URL 사용:', socketUrlToUse);
      }
      
      // socketUrl에서 serverId 추출 또는 authStore에서 가져오기
      let serverId = this.authStore.serverId || localStorage.getItem('serverId');
      
      // socketUrl에 serverId가 없고, 추출한 serverId가 있으면 URL에 추가
      if (serverId) {
        try {
          const urlObj = new URL(socketUrlToUse);
          // 이미 serverId가 URL에 포함되어 있지 않은 경우에만 추가
          if (!urlObj.searchParams.has('serverId')) {
            urlObj.searchParams.set('serverId', serverId);
            socketUrlToUse = urlObj.toString();
            console.log('[WebSocket] ServerId 추가:', serverId);
          } else {
            console.log('[WebSocket] ServerId 이미 URL에 포함됨:', urlObj.searchParams.get('serverId'));
          }
        } catch (error) {
          console.warn('[WebSocket] ServerId 추가 실패:', error);
        }
      } else {
        console.warn('[WebSocket] ServerId를 찾을 수 없습니다.');
      }
      
      // 최종 연결 URL 로그 출력 (디버깅용)
      console.log('[WebSocket] 최종 연결 URL:', socketUrlToUse);
      
      const setupOption = {
        skipNegotiation: true,
        transport: SignalR.HttpTransportType.WebSockets,
        accessTokenFactory: () => this.authStore.user.accessToken,
        headers: { authorization: 'Bearer ' + this.authStore.user.accessToken },
        withCredentials: true
      };
      ws = new SignalR.HubConnectionBuilder()
        .withUrl(socketUrlToUse, setupOption)
        .withAutomaticReconnect({
          nextRetryDelayInMilliseconds: retryContext => {
            // 재시도 간격: 0초, 2초, 10초, 30초
            if (retryContext.previousRetryCount === 0) return 0;
            if (retryContext.previousRetryCount === 1) return 2000;
            if (retryContext.previousRetryCount === 2) return 10000;
            return 30000;
          }
        })
        .configureLogging(SignalR.LogLevel.Information) // 로깅 설정 (선택 사항)
        .build();
      
      // 재접속 이벤트 핸들러 설정
      ws.onreconnecting(() => {
        console.log('재접속 중...');
      });

      ws.onreconnected(async (connectionId) => {
        console.log('재접속 완료:', connectionId);
        await handleReconnection(ws, this);
        // Heartbeat 다시 시작
        startHeartbeat(ws, this);
      });

      ws.start()
        .then(async () => {
          // Heartbeat 시작
          startHeartbeat(ws, this);
          // 초기 연결 시 재접속 처리 (활성 작업 복구)
          await handleReconnection(ws, this);
        })
        .catch(error => {
          console.error('연결 실패:', error);
        });
      
      // 연결 종료 시 Heartbeat 정리
      ws.onclose(() => {
        stopHeartbeat();
      });
      
      Vue.prototype.$ws = ws;

      if (urlStock != null ) {  // urlStock이 null이 아니고, wsStock이 null일 때만 연결 생성
        // wsStock URL에도 serverId 추가 (ws와 동일한 방식)
        let stockUrlToUse = urlStock;
        if (serverId) {
          try {
            const stockUrlObj = new URL(stockUrlToUse);
            if (!stockUrlObj.searchParams.has('serverId')) {
              stockUrlObj.searchParams.set('serverId', serverId);
              stockUrlToUse = stockUrlObj.toString();
              console.log('[WebSocket] wsStock ServerId 추가:', serverId);
            }
          } catch (error) {
            console.warn('[WebSocket] wsStock ServerId 추가 실패:', error);
          }
        }

        wsStock = new SignalR.HubConnectionBuilder()
          .withUrl(stockUrlToUse, setupOption)
          .withAutomaticReconnect({
            nextRetryDelayInMilliseconds: retryContext => {
              // 재시도 간격: 0초, 2초, 10초, 30초
              if (retryContext.previousRetryCount === 0) return 0;
              if (retryContext.previousRetryCount === 1) return 2000;
              if (retryContext.previousRetryCount === 2) return 10000;
              return 30000;
            }
          })
          .configureLogging(SignalR.LogLevel.Information) // 로깅 설정 (선택 사항)
          .build();

        // 재접속 이벤트 핸들러 설정 (wsStock)
        wsStock.onreconnecting(() => {
          console.log('wsStock 재접속 중...');
        });

        wsStock.onreconnected(async (connectionId) => {
          console.log('wsStock 재접속 완료:', connectionId);
          await handleReconnection(wsStock, this);
        });

        wsStock.start()
          .then(async () => {
            console.log("wsStock 연결 성공");
            // 초기 연결 시 재접속 처리
            await handleReconnection(wsStock, this);
          })
          .catch(error => {
            console.error('wsStock 연결 실패:', error);
          });

        // wsStock을 Vue 인스턴스에 등록
        Vue.prototype.$wsStock = wsStock;
      } else if (urlStock == null) {
        console.error('URL이 null입니다. 연결을 시도할 수 없습니다.');
      }

      let events = this.$options['echo'];
      if (!events) {
        return;
      }

      Object.keys(events).forEach(function (key) {
        ws.on(key, async (...args) => {
          try {
            return await events[key].bind(this)(args);
          } catch (e) {
            console.error('error methods setupWs', e);
          }
        });
      }, this);




    };

    Vue.mixin({
      echo: {
        async UserConnected(payload) {
          this.socketStore.setConnectionId(payload[0]);
          console.log('연결 성공:' + payload);
          // 초기 연결 시 재접속 처리 (활성 작업 복구)
          if (this.$ws && this.$ws.connection?._connectionState === 'Connected') {
            await handleReconnection(this.$ws, this);
            startHeartbeat(this.$ws, this);
          }
        },
        UserDisconnected(payload) {
          this.socketStore.setConnectionId(null);
          console.log('연결 끊김:' + payload);
        },
        SocketIdxLimitExceeded(payload) {
          // SocketIdx 제한 초과 메시지 처리
          const message = payload || '동시접속 10개 까지 가능합니다.';
          console.log('SocketIdx 제한 초과:', message);
          
          // 로그인 페이지로 리다이렉트하고 메시지 표시
          if (this.$router && this.$router.currentRoute.path !== '/user') {
            // 로그아웃 처리 (토큰 제거)
            if (this.authStore) {
              this.authStore.logout();
            }
            // 로그인 페이지로 이동
            this.$router.push('/user').then(() => {
              // 메시지 표시 (다음 틱에서 실행하여 라우터 이동 후 표시)
              this.$nextTick(() => {
                if (this.common && this.common.setToast) {
                  this.common.setToast('yellow', 'info', message);
                } else {
                  // common이 없는 경우 alert 사용
                  alert(message);
                }
              });
            });
          } else {
            // 라우터가 없는 경우 메시지만 표시
            if (this.common && this.common.setToast) {
              this.common.setToast('yellow', 'info', message);
            } else {
              alert(message);
            }
          }
        },
        heartbeatreceived(payload) {
          // Heartbeat 수신 확인 (백엔드에서 호출)
          // 연결 상태 유지 확인용으로 사용 가능
          console.log('Heartbeat received:', payload);
          
          // payload 형식: [타임스탬프, IP주소, socketIdx] 또는 배열로 감싸진 형태
          if (Array.isArray(payload) && payload.length > 0) {
            // payload[0]이 배열인 경우: [[타임스탬프, IP주소, socketIdx]]
            if (Array.isArray(payload[0]) && payload[0].length >= 3) {
              const socketIdx = payload[0][2];
              if (socketIdx !== undefined && socketIdx !== null) {
                this.socketStore.setSocketIdx(socketIdx);
                updateTitleWithSocketIdx(this);
              }
            }
            // payload 자체가 [타임스탬프, IP주소, socketIdx] 형태인 경우
            else if (payload.length >= 3 && typeof payload[2] !== 'undefined') {
              const socketIdx = payload[2];
              if (socketIdx !== undefined && socketIdx !== null) {
                this.socketStore.setSocketIdx(socketIdx);
                updateTitleWithSocketIdx(this);
              }
            }
            // 기존 형식 지원 (하위 호환)
            else {
              const data = typeof payload[0] === 'string' ? JSON.parse(payload[0]) : payload[0];
              if (data && data.socketIdx !== undefined) {
                this.socketStore.setSocketIdx(data.socketIdx);
                updateTitleWithSocketIdx(this);
              } else if (typeof payload[0] === 'string' || typeof payload[0] === 'number') {
                this.socketStore.setSocketIdx(payload[0]);
                updateTitleWithSocketIdx(this);
              }
            }
          }
        },
        __validate__(payload) {
          // SignalR 연결 검증 메서드 (백엔드에서 호출)
          // 연결 유효성 검증용으로 사용
          console.log('Connection validated:', payload);
        },
        async ExtentionsProxy(payload) {
          if (payload.length !== 5) {
            console.log('payload Error Length:' + payload.length);
            return;
          }
          if (this.socketStore.connectionId == null) {
            console.log('connection Id null');
            return;
          }
          this.socketStore.proxyRequestModel = payload;
          let responseModel = null;
          switch (payload[0]) {
            case 'GET':
              responseModel = await chromeExAPI.GetMethod(payload[1], payload[2], payload[4]); // URL
              break;
            case 'POST':
              responseModel = await chromeExAPI.PostMethod(
                payload[1],
                payload[2],
                payload[3],
                payload[4]
              );
              break;
            case 'PUT':
              responseModel = await chromeExAPI.PutMethod(
                payload[1],
                payload[2],
                payload[3],
                payload[4]
              );
              break;
            case 'DELETE':
              responseModel = await chromeExAPI.DeleteMethod(
                payload[1],
                payload[2],
                payload[3],
                payload[4]
              );
              break;
            case 'PATCH':
              responseModel = await chromeExAPI.PatchMethod(
                payload[1],
                payload[2],
                payload[3],
                payload[4]
              );
              break;
            case 'MULITPART':
              responseModel = await chromeExAPI.MultipartMethod(payload[1], payload[2], payload[3]);
              break;
            case 'GetBrowserHtml':
              responseModel = await chromeExAPI.GetBrowserHtmlMethod(payload[1], payload[2]);
              break;
          }
          this.socketStore.proxyResponseModel = responseModel;
          return responseModel;
        },
        async ImageBase64Convert(payload) {
          let item = await chromeExAPI.ImageMethod(payload[0]);
          return item;
        },
        async RequestWebpToJpg(payload) {
          let responseData = {
            body: null,
            headers: null
          };
          try {
            // 크롬 익스텐션에서 응답을 완전히 받을 때까지 대기
            let responseModel = await chromeExAPI.ImageMethod(payload[0]);
            
            // 응답이 유효한지 확인
            if (!responseModel || !responseModel.body) {
              throw new Error('Invalid response from extension: missing body');
            }
            
            const type = payload[0].includes('.png') ? 'png' : 'jpg';
            // imageLoadCallback도 완료될 때까지 대기
            const processedBody = await imageLoadCallback(responseModel.body, payload[1], payload[2], type);
            
            responseData = {
              body: processedBody,
              headers: null
            };
            return responseData;
          } catch (error) {
            console.error('RequestWebpToJpg error:', error);
            // 에러 발생 시에도 응답 구조를 유지하여 백엔드로 전달
            throw error;
          }
        },
        async SetLocalStorage(payload) {
          let response = null;
          try {
            localStorage.setItem(payload[0], payload[1]);
            response = localStorage.getItem(payload[0]);
          } catch (ex) {
            console.log(ex);
          }
          return response;
        },
        async GetLocalStorage(payload) {
          let response = null;
          try {
            response = localStorage.getItem(payload[0]);
          } catch (ex) {
            console.log(ex);
          }
          return response;
        },
        NoticeCollectResult(payload) {
          console.log("NoticeCollectResult(payload)");
          const data = JSON.parse(payload);
          
          // 작업 ID가 포함되어 있으면 작업 ID 기반 콜백 호출
          if (data.workId && this.socketStore.workIdCallbacks.has(data.workId)) {
            this.socketStore.handleWorkResult(data.workId, data);
          }
          
          // 기존 방식 유지 (하위 호환)
          this.socketStore.setCollectList(false, data);
          // this.socketStore.setType('COLLECT');
          this.socketStore.setFinish('');
        },
        NoticeCollectFinish(payload) {
          if (payload[0] === '상품수집 완료') {
            this.socketStore.setFinish('COLLECT');
            this.socketStore.setType('');
            this.socketStore.setProgress('stop');
          }
        },
        NoticeUploadResult(payload) {
          const data = JSON.parse(payload);
          
          // 작업 ID가 포함되어 있으면 작업 ID 기반 콜백 호출
          if (data.workId && this.socketStore.workIdCallbacks.has(data.workId)) {
            this.socketStore.handleWorkResult(data.workId, data);
          }
          
          // 기존 방식 유지 (하위 호환)
          this.socketStore.setUploadList(false, data);
          this.socketStore.setType('UPLOAD');
          this.socketStore.setFinish('');
        },
        NoticeMarketProductCollectResult(payload) {
          const raw = Array.isArray(payload) ? payload[0] : payload;
          const data = typeof raw === 'string' ? JSON.parse(raw) : raw;

          console.log('[NoticeMarketProductCollectResult] data:', data);

          if (data?.workId && this.socketStore.workIdCallbacks.has(data.workId)) {
            this.socketStore.handleWorkResult(data.workId, data);
          }

          this.socketStore.setMarketProductList(false, data);
        },
        NoticeUploadFinish(payload) {
          if (payload[0] === '상품등록 완료') {
            this.socketStore.setFinish('UPLOAD');
            this.socketStore.setType('');
            this.socketStore.setProgress('stop');
          }
        },
        NoticeStockLinkResult(payload) {
          const data = JSON.parse(payload);
          
          // 작업 ID가 포함되어 있으면 작업 ID 기반 콜백 호출
          if (data.workId && this.socketStore.workIdCallbacks.has(data.workId)) {
            this.socketStore.handleWorkResult(data.workId, data);
          }
          
          // 기존 방식 유지 (하위 호환)
          this.socketStore.setStockLinkList(false, data);
          this.socketStore.setType('STOCKLINK');
          this.socketStore.setFinish('');
        },
        NoticeStockLinkFinish(payload) {
          if (payload[0] === '재고연동 완료') {
            this.socketStore.setFinish('STOCKLINK');
            this.socketStore.setType('');
            this.socketStore.setProgress('stop');
          }
        },
        async ExtensionsCookie(payload) {
          const res = await chromeExAPI.CheckSiteLogin(payload);
          return res.responseMsg;
        },
        NoticeStatusChangeResult(result) {
          let deleteResult = {};
          result.forEach(res => {
            const parsed = JSON.parse(res);
            deleteResult = { ...deleteResult, ...parsed };
            
            // 작업 ID가 포함되어 있으면 작업 ID 기반 콜백 호출
            if (parsed.workId && this.socketStore.workIdCallbacks.has(parsed.workId)) {
              this.socketStore.handleWorkResult(parsed.workId, parsed);
            }
          });
          this.socketStore.setDeleteResult(deleteResult);
        },
        NoticeStatusChangeFinish(result) {
          this.socketStore.setDeleteStatus(JSON.parse(result[0]));
        },
        NoticeStockZeroResult(result) {
          const log = JSON.parse(result);
          this.socketStore.setSoldOutLog(log);
        },
        // 작업 결과 수신 (작업 ID 포함)
        WorkResult(payload) {
          const workId = payload[0];
          const result = payload[1];
          if (this.socketStore.workIdCallbacks.has(workId)) {
            this.socketStore.handleWorkResult(workId, result);
          }
        },
        // 재접속 업데이트 완료 알림
        ReconnectionUpdated(payload) {
          const updatedCount = payload[0];
          console.log(`재접속 업데이트 완료: ${updatedCount}개 작업`);
        }
      }
    });
  }
};
